export function initInspeksiGardu() {
    // Image Preview Logic
    $('.img-input').on('change', function() {
        const file = this.files[0];
        const preview = $(this).siblings('.preview-container');
        if (file) {
            const reader = new FileReader();
            reader.onload = function(e) {
                preview.find('img').attr('src', e.target.result);
                preview.removeClass('d-none');
            }
            reader.readAsDataURL(file);
        } else {
            preview.addClass('d-none');
        }
    });

    $('#formInspeksi').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const btn = $('#btnSubmitGardu');
        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Menyimpan...');
        
        const formData = new FormData(this);
        $.ajax({
            url: $(this).attr('action'),
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(res) {
                if (res.status === 'success') {
                    Swal.fire({
                        title: 'Berhasil',
                        text: res.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then(() => location.reload());
                }
            },
            error: function(err) {
                btn.prop('disabled', false).text('Simpan Data Gardu');
                Swal.fire('Error', err.responseJSON?.message || 'Terjadi kesalahan', 'error');
            }
        });
    });
}
